export default "__VITE_ASSET__B0Hni0zB__"